import { useEffect, useState } from "react";
import { FaFileMedical } from "react-icons/fa";
import {
  Alert,
  Divider,
  FormControlLabel,
  FormGroup,
  FormControl,
  Radio,
  RadioGroup,
  Switch,
  TextField,
  Stack,
} from "@mui/material";
import {
  getCombos,
  getUsuario,
  getCboMunicipios,
  getPersonas,
  setPlantillaSencilla,
  setUsuario,
  updateUsuario,
} from "../componentes/api.js";
import VentanaCrear from "../comun/VentanaCrear.jsx";
import BarraBotones from "../comun/BarraBotones.jsx";
import UsuarioLista from "./UsuarioLista.jsx";

const Usuarios = (props) => {
  /**Para cargar los datos de los combos */
  const [cargos, setCargos] = useState([]);
  const [auditores, setAuditores] = useState([]);
  const [tipoDocumentos, setTipoDocumentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [actualizaListado, setActualizaListado] = useState(false);

  const [datos, setDatos] = useState({
    idUsuario: "",
    nbres: "",
    apellidos: "",
    noDocumento: "",
    tipoDocumento: "",
    municipio: 0,
    direccion: "",
    celular: "",
    correo: "",
    clave: "",
    tipoParticipante: "2",
    cargo: 0,
    activo: true,
    usuarioReg: props.idUsuario,
    proyecto: props.idProyecto,
    auditor: 0,
  });

  useEffect(() => {
    nuevo();
    cargarCombos({ Tabla: "cargos", Campo: "" }, "cargo");
    cargarCombos({ Tabla: "tipo_documento", Campo: "" }, "tipoDocumento");
    cargarMunicipios();
    cargarAuditores();
  }, [props.idProyecto]);

  const asignarDato = (event) => {
    event.preventDefault();
    if (event.target.name === "activo") {
      setDatos({ ...datos, [event.target.name]: event.target.checked });
    } else {
      setDatos({ ...datos, [event.target.name]: event.target.value });
      if (event.target.name === "tipoParticipante") {
        if (actualizaListado === false) {
          setActualizaListado(true);
        } else {
          setActualizaListado(false);
        }
      }
    }
  };

  const buscarUsuario = async (doc) => {
    try {
      const response = await getUsuario({ noDocumento: doc });
      if (response.data.length !== 0) {
        setDatos({
          ...datos,
          ["idUsuario"]: response.data[0].Id,
          ["nbres"]: response.data[0].Nbres,
          ["apellidos"]: response.data[0].Apellidos,
          ["noDocumento"]: response.data[0].NoDocumento,
          ["tipoDocumento"]: response.data[0].TipoDocumento,
          ["municipio"]: response.data[0].Municipio,
          ["direccion"]: response.data[0].Direccion,
          ["celular"]: response.data[0].Celular,
          ["correo"]: response.data[0].Correo,
          ["tipoParticipante"]: response.data[0].TipoParticipante,
          ["idCargo"]: response.data[0].Cargo,
          ["activo"]: response.data[0].Activo === 1 ? true : false,
          ["idAuditor"]: response.data[0].Auditor,
        });
      }
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al buscar el número del Documento de Identidad",
        error,
      ]);
    }
  };

  const botones = (boton) => {
    if (boton === 0) nuevo(); //Nuevo
    else if (boton === 1) validarDatos(); //Grabar registro
    else if (boton === 2) imprimir(); //Imprimir registro
    else if (boton === 3) exportar(); //Exportar registro
    else if (boton === 4) nuevo(); //Limpiar, igual a nuevo
  };

  const cargarCombos = async (datos, cbo) => {
    try {
      const response = await getCombos(datos);
      if (cbo === "tipoDocumento") {
        setTipoDocumentos(response.data);
      } else if (cbo === "cargo") {
        setCargos(response.data);
      } else if (cbo === "auditor") {
        setAuditores(response.data);
      }
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Combos",
        error,
      ]);
    }
  };

  const cargarMunicipios = async () => {
    try {
      const response = await getCboMunicipios();
      setMunicipios(response.data);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Municipios",
        error,
      ]);
    }
  };

  const cerrarVentanaCrear = () => {
    setMostrarCrear(false);
  };

  const exportar = () => {
    props.mostrarMsg(["OK, exportará los datos"]);
  };

  const grabarCampo = async (nbre) => {
    try {
      let plantilla = {
        tabla: "tipo_documento",
        nbre: nbre,
        activo: "1",
        idUsuario: props.idUsuario,
      };
      const response = await setPlantillaSencilla(plantilla);
      setDatos({ ...datos, tipoDocumento: response.data.Id });
      cargarCombos({ Tabla: "tipo_documento", Campo: "" }, "tipoDocumento");
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar el Tipo de Documento",
        error,
      ]);
    }
  };

  const grabarRegistro = async () => {
    try {
      setActualizaListado(false);
      const result = await setUsuario(datos);
      props.mostrarMsg(["Usuario Grabado"]);
      setActualizaListado(true);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Grabar al Beneficiario del Proyecto",
        error,
      ]);
    }
  };

  const imprimir = () => {
    props.mostrarMsg(["OK, Imprime los datos"]);
  };

  const cargarAuditores = async () => {
    try {
      const response = await getPersonas(datos.tipoParticipante);
      setAuditores(response.data);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Auditores",
        error,
      ]);
    }
  };

  const modificarRegistro = async () => {
    try {
      setActualizaListado(false);
      await updateUsuario(datos);
      setActualizaListado(true);
      props.mostrarMsg(["Datos del Usuario actualizados!"]);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al Modificar los Datos del Beneficiario del Proyecto",
        error,
      ]);
    }
  };

  const mostrarVentanaCrear = (event, titulo) => {
    event.preventDefault();
    setMostrarCrear(true);
  };

  const nuevo = () => {
    setDatos({
      idUsuario: "",
      nbres: "",
      apellidos: "",
      noDocumento: "",
      tipoDocumento: datos.tipoDocumento || "",
      municipio: datos.municipio || 0,
      direccion: "",
      celular: "",
      correo: "",
      clave: "",
      tipoParticipante: datos.tipoParticipante || "2",
      cargo: datos.idCargo || 0,
      activo: true,
      usuarioReg: props.idUsuario,
      proyecto: props.idProyecto,
      auditor: datos.idAuditor || 0,
    });
  };

  const validarDatos = () => {
    if (datos.nbres === "") {
      props.mostrarMsg(["Por favor digite los Nombres!"]);
    } else if (datos.apellidos === "") {
      props.mostrarMsg(["Por favor digite los Apellidos!"]);
    } else if (datos.tipoDocumento === "") {
      props.mostrarMsg(["Por favor digite el Tipo de Documento!"]);
    } else if (datos.noDocumento === "") {
      props.mostrarMsg(["Por favor digite el Número de Documento!"]);
    } else if (datos.municipio === "") {
      props.mostrarMsg(["Por favor seleccione un Municipio!"]);
    } else if (datos.direccion === "") {
      props.mostrarMsg(["Por favor digite la Dirección!"]);
    } else if (datos.celular === "") {
      props.mostrarMsg(["Por favor digite el Número de Celular!"]);
    } else if (datos.clave === "" && datos.id === "") {
      props.mostrarMsg([
        "Por favor digite una Clave de Acceso a la Plataforma!",
      ]);
    } else {
      if (datos.tipoParticipante === "2") {
        //Equipo de trabajo
        if (datos.cargo === "") {
          props.mostrarMsg(["Por favor seleccione un Componente!"]);
        } else if (datos.auditor === "") {
          props.mostrarMsg([
            "Por favor seleccione el funcionario que le hará el Seguimiento!",
          ]);
        } else {
          {
            datos.idUsuario === "" ? grabarRegistro() : modificarRegistro();
          }
        }
      } else {
        {
          datos.idUsuario === "" ? grabarRegistro() : modificarRegistro();
        }
      }
    }
  };

  return (
    <>
      <div className="container-fluid card shadow mt-2" id="divTop">
        <div className="row mt-3 mb-3">
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Alert severity="success">
              <strong>INTEGRANTES DEL PROYECTO</strong>
            </Alert>
          </Stack>
        </div>

        <div className="row mt-3">
          <Divider component="ul" />
          <BarraBotones
            botones={botones}
            btnActivos={[true, true, false, true, true]}
          />
        </div>

        <div className="row">
          <Alert icon={false} severity="info">
            Seleccione el tipo de Participante
          </Alert>
        </div>

        <div className="row mb-3 mx-1">
          <div className="col-sm-8">
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name="tipoParticipante"
                value={datos.tipoParticipante}
              >
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="Equipo de Trabajo"
                  onChange={(event) => asignarDato(event)}
                />

                <FormControlLabel
                  value="1"
                  control={<Radio />}
                  label="Super Usuario"
                  onChange={(event) => asignarDato(event)}
                />
              </RadioGroup>
            </FormControl>
          </div>

          <div className="col-sm-4">
            <button className="btn btn-primary">Importar de Excel</button>
          </div>
        </div>

        <hr />

        <div className="container-fluid" id="divTop">
          <div className="row mt-3 mb-3">
            <Stack sx={{ width: "100%" }} spacing={2}>
              <Alert severity="success">
                <strong>INFORMACION DEL USUARIO</strong>
              </Alert>
            </Stack>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="input-group form-floating mt-2">
                <select
                  name="tipoDocumento"
                  className="form-select form-control"
                  aria-label="tipoDocumento"
                  value={datos.tipoDocumento}
                  onChange={(event) => asignarDato(event)}
                >
                  <option key="0" value="0">
                    Por favor seleccione un Tipo de Documento...
                  </option>
                  {tipoDocumentos.map((reg) => {
                    return (
                      <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                        {" "}
                        {reg.Nbre}{" "}
                      </option>
                    );
                  })}
                </select>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={(event) => {
                    mostrarVentanaCrear(event, "TIPO DE DOCUMENTOS");
                  }}
                >
                  <FaFileMedical />
                </button>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="row mt-2">
                <TextField
                  style={{ marginTop: "10px" }}
                  InputLabelProps={{ shrink: true }}
                  name="noDocumento"
                  label="Número de Documento de Identidad"
                  className="form-control"
                  onChange={(event) => asignarDato(event)}
                  onBlur={(event) => buscarUsuario(event.target.value)}
                  type="text"
                  value={datos.noDocumento}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="nbres"
                label="Nombres"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="text"
                value={datos.nbres}
              />
            </div>

            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="apellidos"
                label="Apellidos"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="text"
                value={datos.apellidos}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="row form-floating mt-2">
                <select
                  type="text"
                  className="form-control"
                  name="municipio"
                  value={datos.municipio}
                  onChange={(event) => {
                    asignarDato(event);
                  }}
                >
                  <option key="0" value="0">
                    Por favor seleccione un Municipio...
                  </option>
                  {municipios.map((reg) => {
                    return (
                      <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                        {" "}
                        {reg.Nbre}{" "}
                      </option>
                    );
                  })}
                </select>
                <label htmlFor="municipio">Municipio de Residencia</label>
              </div>
            </div>

            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="direccion"
                label="Dirección de Residencia"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="text"
                value={datos.direccion}
              />
            </div>
          </div>

          <div className="row mt-2">
            <TextField
              style={{ marginTop: "10px" }}
              InputLabelProps={{ shrink: true }}
              name="celular"
              label="Número de Celular de Contacto"
              className="form-control"
              onChange={(event) => asignarDato(event)}
              type="text"
              value={datos.celular}
            />
          </div>

          <div className="row">
            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="correo"
                label="Dirección de Correo"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="text"
                value={datos.correo}
              />
            </div>
            <div className="col-sm-6">
              <TextField
                style={{ marginTop: "10px" }}
                InputLabelProps={{ shrink: true }}
                name="clave"
                label="Clave de Acceso"
                className="form-control"
                onChange={(event) => asignarDato(event)}
                type="password"
                value={datos.clave}
              />
            </div>
          </div>

          {datos.tipoParticipante === "2" && (
            <div className="row mt-3">
              <div className="col-sm-6">
                <div className="row form-floating mt-2">
                  <select
                    type="text"
                    className="form-control"
                    name="cargo"
                    value={datos.cargo}
                    onChange={(event) => asignarDato(event)}
                  >
                    <option key="0" value="0">
                      Por favor seleccione un Componente...
                    </option>
                    {cargos.map((reg) => {
                      return (
                        <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                          {" "}
                          {reg.Nbre}{" "}
                        </option>
                      );
                    })}
                  </select>
                  <label htmlFor="cargo">Componente del Equipo</label>
                </div>
              </div>

              <div className="col-sm-6">
                <div className="row form-floating mt-2">
                  <select
                    type="text"
                    className="form-control"
                    name="auditor"
                    value={datos.auditor}
                    onChange={(event) => asignarDato(event)}
                  >
                    <option key="0" value="0">
                      Por favor seleccione un Auditor...
                    </option>
                    {auditores.map((reg) => {
                      return (
                        <option key={reg.Id} value={reg.Id} label={reg.Nbres}>
                          {" "}
                          {reg.Nbres}{" "}
                        </option>
                      );
                    })}
                  </select>
                  <label htmlFor="auditor">
                    Funcionario que hace Seguimiento
                  </label>
                </div>
              </div>
            </div>
          )}

          <div className="row mt-2">
            <FormGroup>
              <FormControlLabel
                name="activo"
                control={
                  <Switch
                    checked={datos.activo}
                    onChange={(event) => asignarDato(event)}
                    inputProps={{ "aria-label": "Activo" }}
                    //defaultChecked
                  />
                }
                label="Estado"
                labelPlacement="start"
                //onChange={asignarDato}
              />
            </FormGroup>
          </div>

          <div className="row">
            <button className="btn btn-primary">
              Agregar este usuario a este Proyecto
            </button>
          </div>

          <div className="row mt-3">
            <Divider component="ul" />
            <BarraBotones
              botones={botones}
              btnActivos={[true, true, false, true, true]}
            />
          </div>

          {mostrarCrear === true && (
            <VentanaCrear
              titulo={"TIPO DE DOCUMENTO"}
              grabarCampo={grabarCampo}
              mostrarCrear={mostrarCrear}
              setMostrarCrear={setMostrarCrear}
            />
          )}
        </div>

        <UsuarioLista
          proyecto={props.idProyecto}
          tipoParticipante={datos.tipoParticipante} //Super usuario o Equipo de trabajo
          actualizaListado={actualizaListado}
        />
      </div>
    </>
  );
};

export default Usuarios;
